import React, { useState } from "react";
import "./Releases.css";

const videos = [
  { id: "Zo-tXDXIH2M", title: "Glimpses of IIT Delhi's International Women's Day 2025 Celebration" },
  { id: "kGE6Iy26ZOE", title: "IIT Delhi Launches Chidambaram Memorial Lecture Series on National Science Day - 28th February 2025" },
  { id: "ZUo-PK2rIFI", title: "IIT Delhi's celebration of its 67th Foundation Day on 27th Jan, 2025" },
  { id: "dvUkKRFe__Y", title: "IIT Delhi Welcomes Mr. Jake Sullivan (U.S National Security Advisor)" },
  { id: "_zloyPowt0Q", title: "Renewable Energy - A Sustainable Solution For Humanity by Prof. BHIM SINGH / IIT Delhi" },
  { id: "hhxjYhE7o0M", title: "ANVESHAN UG Engagement Series, IIT Delhi, 26 Oct 2024" },
  { id: "N27E3eJSGns", title: "Institute Lecture By Prof. John Gero (University of North Carolina at Charlotte) C.S.A" },
  { id: "PRD6htPDaU8", title: "Institute Lecture by Prof. Mortel Meldal and Interaction with Students by Smt. Meenakshi Lekhi." }
];

export default function GlimpsesList() {
  return (
    <section className="podcast_section">
      {videos.map((video, index) => (
        <LazyVideo key={index} videoId={video.id} title={video.title} />
      ))}
    </section>
  );
}

const LazyVideo = ({ videoId, title }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="podcast_item">
      {!loaded ? (
        <div className="thumbnail-container" onClick={() => setLoaded(true)}>
          <img
            className="thumbnail"
            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
            alt={title}
          />
          <div className="play-button">▶</div>
        </div>
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          loading="lazy"
        ></iframe>
      )}
    </div>
  );
};
